import { Grid, makeStyles, MenuItem, TextField } from "@material-ui/core";
import { FC } from "react";
import { PAGINATION_PAGE_SIZES } from "../constants/common";

const useStyles = makeStyles({
  select: {
    "&.MuiSelect-select": {
      fontSize: "16px",
    },
  },
});

type PaginationPageSizeProps = {
  pageSizeValue: number;
  handlePageSizeChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
};

const PaginationPageSize: FC<PaginationPageSizeProps> = ({
  pageSizeValue,
  handlePageSizeChange,
}) => {
  const classes = useStyles();

  return (
    <Grid item>
      <TextField
        select
        value={pageSizeValue}
        onChange={handlePageSizeChange}
        style={{
          padding: 0,
        }}
        SelectProps={{
          classes: {
            select: classes.select,
          },
        }}>
        {PAGINATION_PAGE_SIZES.map((size) => (
          <MenuItem
            key={size}
            value={size}
            style={{
              fontSize: "16px",
            }}>
            {size}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  );
};

export default PaginationPageSize;
